//================= [JS] ======================================
import {i18n} from '@/common/i18n';
import {Routes} from '@/common/enums/Routes';
//================= [VUE COMPONENTS] ==========================

export const diaryRoutes = [
  {
    path: i18n.global.t('routes.diary.diary'),
    name: Routes.DIARY,
    component: () => import('@/components/diary/MyDiary.vue'),
    meta: {
      title: i18n.global.t('titles.diary.diary'),
      active: 'diary',
      coaching: 'diary',
      layout: 'user',
    },
  },
  {
    path: i18n.global.t('routes.diary.diaryShow'),
    name: Routes.DIARY_SHOW,
    component: () => import('@/components/diary/DiaryShow.vue'),
    meta: {
      title: i18n.global.t('titles.diary.diaryShow'),
      active: 'diary',
      coaching: 'diary',
      layout: 'flex',
    },
  },
];
